import { UserAuthData } from "./auth";

/**
 * UserLogin is an event that will be posted from a child, this event is watched for in the AuthService
 *
 * Bootstrap is to be used to setup a child application such as informing the child of the parent's target origin along with authentication data.
 *
 * RouteChanged is to be used for an aesthetic window history push and not a redirect.
 *
 * Redirect is when a child posts to the host to redirect to a different child/route.
 */
export enum ApplicationEventsEnum {
  UserAuthData = 'UserAuthData',
  UserAuthDataRefreshed = 'UserAuthDataRefreshed',
  GetAuthToken = 'GetAuthToken',
  OriginSiteUrl = 'OriginSiteUrl',
  RouteChanged = 'RouteChanged',
  Redirect = 'Redirect',
  Logout = 'Logout'
}

// Outgoing
export type UserLoginEvent = {
  type: ApplicationEventsEnum.UserAuthData;
  message: UserAuthData;
  source: string;
}

export type OriginSiteUrl = {
  type: ApplicationEventsEnum.OriginSiteUrl;
  message: string;
  source: string;
}

// Incomming
export type RouteChangedEvent = {
  type: ApplicationEventsEnum.RouteChanged;
  message: string;
  source: string;
}

export type AuthTokenRefreshed = {
  type: ApplicationEventsEnum.UserAuthDataRefreshed
  message: UserAuthData;
}

export type LogOut = {
  type: ApplicationEventsEnum.Logout
  message: string;
}

export type GetAuthToken = {
  type: ApplicationEventsEnum.GetAuthToken
  message: string;
}
// interfaces can't be coalesced which is why types are used
/**
 * Coalesced types for use inside of the EventsService
 */
export type NotifyChildEvent = UserLoginEvent | OriginSiteUrl | RouteChangedEvent;

export type NotifyParentEvent = UserLoginEvent | RouteChangedEvent | AuthTokenRefreshed | LogOut | GetAuthToken;
